import { render, staticRenderFns } from "./PaymentIssue.vue?vue&type=template&id=2c9bd2e1&scoped=true&"
import script from "./PaymentIssue.vue?vue&type=script&lang=ts&"
export * from "./PaymentIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9bd2e1",
  null
  
)

export default component.exports